/* eslint-disable max-nested-callbacks */
import { push } from '@lagunovsky/redux-react-router'
import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid, Stack, Typography } from '@mui/material'
import IconCard from 'components/card/IconCard'
import { flatten, isNil, max, orderBy, round, uniq, uniqBy, upperFirst } from 'lodash'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import i18n from 'simple-react-i18n'
import { v4 as uuidv4 } from 'uuid'
import ElementCard from '../../../components/card/ElementCard'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import BuildIcon from '@mui/icons-material/Build'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import NumberField from '../../../components/forms/NumberField'
import RadioButtons from '../../../components/forms/RadioButtons'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import SelectEmail from '../../../components/modal/SelectEmail'
import ProgressCard from '../../../components/card/ProgressCard'
import SieauAction from '../../../components/sieau/SieauAction'
import EventsAction from '../../../events/actions/EventsAction'
import { EVENT_TYPES, EVENT_TYPES_CODES } from '../../../events/constants/EventsConstants'
import MaterielAction from '../../../materiel/actions/MaterielAction'
import CentralDto from '../../../materiel/components/central/dto/CentralDto'
import EquipmentAction from '../../../materiel/components/equipment/actions/EquipmentAction'
import EquipmentWithMaterielsDto from '../../../materiel/components/equipment/dto/EquipmentWithMaterielsDto'
import PowerSupplyDto from '../../../materiel/components/powerSupply/dto/PowerSupplyDto'
import SensorDto from '../../../materiel/components/sensor/dto/SensorDto'
import SimDto from '../../../materiel/components/sim/dto/SimDto'
import SubscriptionAction from '../../../materiel/components/subscription/actions/SubscriptionAction'
import SubscriptionDto from '../../../materiel/components/subscription/dto/SubscriptionDto'
import TelecomDto from '../../../materiel/components/telecom/dto/TelecomDto'
import VariousMaterielDto from '../../../materiel/components/variousMateriel/dto/VariousMaterielDto'
import StationAction from '../../../station/actions/StationAction'
import StationAltimetrySystemsPanel from '../../../station/components/link/StationAltimetrySystemsPanel'
import StationLandmarkPanel from '../../../station/components/link/StationLandmarkPanel'
import { buildCampaignGroups, getInterventionType } from '../../../utils/CampaignUtil'
import { getDate, getDateWithHour, getFullDate, getHour } from '../../../utils/DateUtil'
import { formatHourInput, onChangeDate, onChangeHour, safeBaseDate } from '../../../utils/FormUtils'
import { getMaterialStateIcon, getMaterielIconValue, getMaterielPlural } from '../../../utils/MaterielUtils'
import { hasValue } from '../../../utils/NumberUtil'
import { getUser } from '../../../utils/SettingUtils'
import { getSandreList, removeNullKeys } from '../../../utils/StoreUtils'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import { i18nize } from '../../../utils/StringUtil'
import PiezometryAction from '../../actions/PiezometryAction'
import { EVENT_ACTION, STEPS } from '../../constants/PiezometryEventConstants'
import { getActionMaterielType, getYesOrNo, isLastEvent, isUpdatableEvent } from './EventFormUtils'
import EventCentralCard from './eventMaterielCard/EventCentralCard'
import EventEquipmentCard from './eventMaterielCard/EventEquipmentCard'
import EventSensorCard from './eventMaterielCard/EventSensorCard'
import EventTelecomCard from './eventMaterielCard/EventTelecomCard'
import MaterielCard from './eventMaterielCard/MaterielCard'
import ActionChoicePanel from './modalPanel/ActionChoicePanel'
import DiagnosticChoicePanel from './modalPanel/DiagnosticChoicePanel'
import NewSituationPanel from './modalPanel/NewSituationPanel'
import Other from 'components/actions/Other'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import ToastrAction from 'toastr/actions/ToastrAction'
import { STATION_TYPE_NAME } from '../../../station/constants/StationConstants'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import { CardTitle } from 'components/card/NewCard'
import { LastUpdateCard } from 'components/card/LastUpdateCard'
import { darkBlue, lightGrey, whiteColor } from 'utils/constants/ColorTheme'

const EMPTY_MATERIELS = {
    centrals: [],
    sensors: [],
    telecoms: [],
    sims: [],
    variousMateriels: [],
    powerSupplies: [],
    equipments: [],
    subscriptions: [],
}

const PiezometerEventForm = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const { id, code } = useParams()

    const isNew = code === '0'

    const {
        piezometer: piezometerStore,
        event: eventStore,
        stationEvents,
        contacts,
        contributors,
        centrals: centralsStore,
        centralTypes,
        centralsLastSituations,
        powerSupplies: powerSuppliesStore,
        powerSupplyTypes,
        powerSuppliesLastSituations,
        sensors: sensorsStore,
        sensorTypes,
        sensorsLastSituations,
        sims: simsStore,
        simTypes,
        simsLastSituations,
        telecoms: telecomsStore,
        telecomTypes,
        telecomsLastSituations,
        variousMateriels: variousMaterielsStore,
        variousMaterielTypes,
        variousMaterielsLastSituations,
        equipments: equipmentsStore,
        equipmentTypes,
        equipmentsLastSituations,
        eventPiezometerReplacementAction,
        subscriptions: subscriptionsStore,
        subscriptionTypes,
        subscriptionsLastSituations,
        eventPiezometerDiagnostics,
        eventPiezometerSolutions,
        eventPiezometerActions,
        materielStates,
        stationCentralAssignments,
        stationPowerSupplyAssignments,
        stationSensorAssignments,
        stationSimAssignments,
        stationTelecomAssignments,
        stationVariousMaterielAssignments,
        stationEquipmentAssignments,
        stationSubscriptionAssignments,
        stationCentral,
        stationPowerSupply,
        stationSensor,
        stationSim,
        stationTelecom,
        stationVariousMateriel,
        stationEquipment,
        stationSubscription,
        piezometryCampaigns,
        piezometryCampaignStations,
        eventAllPiezometerActions,
        materielTypes,
        sandreCodes,
        causeInterventions: causeInterventionsStore,
    } = useSelector(store => ({
        piezometer: store.StationReducer.piezometer,
        event: store.EventsReducer.event,
        stationEvents: store.EventsReducer.stationEvents,
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        centrals: store.CentralReducer.centrals,
        centralTypes: store.CentralReducer.centralTypes,
        centralsLastSituations: store.CentralReducer.centralsLastSituations,
        powerSupplies: store.PowerSupplyReducer.powerSupplies,
        powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
        powerSuppliesLastSituations: store.PowerSupplyReducer.powerSuppliesLastSituations,
        sensors: store.SensorReducer.sensors,
        sensorTypes: store.SensorReducer.sensorTypes,
        sensorsLastSituations: store.SensorReducer.sensorsLastSituations,
        sims: store.SimReducer.sims,
        simTypes: store.SimReducer.simTypes,
        simsLastSituations: store.SimReducer.simsLastSituations,
        telecoms: store.TelecomReducer.telecoms,
        telecomTypes: store.TelecomReducer.telecomTypes,
        telecomsLastSituations: store.TelecomReducer.telecomsLastSituations,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
        variousMaterielsLastSituations: store.VariousMaterielReducer.variousMaterielsLastSituations,
        equipments: store.EquipmentReducer.equipments,
        equipmentTypes: store.EquipmentReducer.equipmentTypes,
        equipmentsLastSituations: store.EquipmentReducer.equipmentsLastSituations,
        eventPiezometerReplacementAction: store.EventsReducer.eventPiezometerReplacementAction,
        subscriptions: store.SubscriptionReducer.subscriptions,
        subscriptionTypes: store.SubscriptionReducer.subscriptionTypes,
        subscriptionsLastSituations: store.SubscriptionReducer.subscriptionsLastSituations,
        eventPiezometerDiagnostics: store.EventsReducer.eventPiezometerDiagnostics,
        eventPiezometerSolutions: store.EventsReducer.eventPiezometerSolutions,
        eventPiezometerActions: store.EventsReducer.eventPiezometerActions,
        materielStates: store.MaterielReducer.materielStates,
        stationCentralAssignments: store.StationReducer.stationCentralAssignments,
        stationPowerSupplyAssignments: store.StationReducer.stationPowerSupplyAssignments,
        stationSensorAssignments: store.StationReducer.stationSensorAssignments,
        stationSimAssignments: store.StationReducer.stationSimAssignments,
        stationTelecomAssignments: store.StationReducer.stationTelecomAssignments,
        stationVariousMaterielAssignments: store.StationReducer.stationVariousMaterielAssignments,
        stationEquipmentAssignments: store.StationReducer.stationEquipmentAssignments,
        stationSubscriptionAssignments: store.StationReducer.stationSubscriptionAssignments,
        stationCentral: store.StationReducer.stationCentral,
        stationPowerSupply: store.StationReducer.stationPowerSupply,
        stationSensor: store.StationReducer.stationSensor,
        stationSim: store.StationReducer.stationSim,
        stationTelecom: store.StationReducer.stationTelecom,
        stationVariousMateriel: store.StationReducer.stationVariousMateriel,
        stationEquipment: store.StationReducer.stationEquipment,
        stationSubscription: store.StationReducer.stationSubscription,
        piezometryCampaigns: store.PiezometryReducer.piezometryCampaigns,
        piezometryCampaignStations: store.PiezometryReducer.piezometryCampaignStations,
        eventAllPiezometerActions: store.EventsReducer.eventAllPiezometerActions,
        materielTypes: store.MaterielReducer.materielTypes,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        causeInterventions: store.EventsReducer.causeInterventions,
    }), shallowEqual)

    const materielsByCategory = {
        central: {
            materiels: centralsStore,
            types: centralTypes,
            lastSituations: centralsLastSituations,
            station: stationCentral,
            assignments: stationCentralAssignments,
        },
        powerSupply: {
            materiels: powerSuppliesStore,
            types: powerSupplyTypes,
            lastSituations: powerSuppliesLastSituations,
            station: stationPowerSupply,
            assignments: stationPowerSupplyAssignments,
        },
        sensor: {
            materiels: sensorsStore,
            types: sensorTypes,
            lastSituations: sensorsLastSituations,
            station: stationSensor,
            assignments: stationSensorAssignments,
        },
        sim: {
            materiels: simsStore,
            types: simTypes,
            lastSituations: simsLastSituations,
            station: stationSim,
            assignments: stationSimAssignments,
        },
        telecom: {
            materiels: telecomsStore,
            types: telecomTypes,
            lastSituations: telecomsLastSituations,
            station: stationTelecom,
            assignments: stationTelecomAssignments,
        },
        variousMateriel: {
            materiels: variousMaterielsStore,
            types: variousMaterielTypes,
            lastSituations: variousMaterielsLastSituations,
            station: stationVariousMateriel,
            assignments: stationVariousMaterielAssignments,
        },
        equipment: {
            materiels: equipmentsStore,
            types: equipmentTypes,
            lastSituations: equipmentsLastSituations,
            station: stationEquipment,
            assignments: stationEquipmentAssignments,
        },
        subscription: {
            materiels: subscriptionsStore,
            types: subscriptionTypes,
            lastSituations: subscriptionsLastSituations,
            station: stationSubscription,
            assignments: stationSubscriptionAssignments,
        },
    }

    const { date: dateParsed, campaignCode: campaignCodeParsed, campaignType, objectives } = queryString.parse(location.search)

    const [isEditMode, setIsEditMode] = useState(isNew)
    const [event, setEvent] = useState({
        date: (dateParsed ? parseInt(dateParsed) : 0) || moment().startOf('day').valueOf(),
        eventType: campaignType || EVENT_TYPES_CODES.CURATIVE,
        graph: '1',
        bankExport: '0',
        eventHour: moment().valueOf(),
        campaignCode: campaignCodeParsed ? parseInt(campaignCodeParsed) : undefined,
        contactCode: isNew ? getUser().contactCode : undefined,
    })
    const [step, setStep] = useState(0)
    const [diagnostics, setDiagnostics] = useState([])
    const [causeInterventions, setCauseInterventions] = useState(isNew && objectives && campaignType !== EVENT_TYPES_CODES.NOT_DONE ? objectives.split(',').map(o => parseInt(o)) : [])
    const [materielCategory, setMaterielCategory] = useState('')
    const [actions, setActions] = useState([])
    const [selectedType, setSelectedType] = useState(undefined)
    const [selectedMateriel, setSelectedMateriel] = useState(undefined)
    const [newSituations, setNewSituations] = useState([])
    const [currentMaterielEventSituation, setCurrentMaterielEventSituation] = useState([])
    const [interventionIndex, setInterventionIndex] = useState(0)
    const [formActions, setFormActions] = useState([])
    const [testSignal, setTestSignal] = useState([])
    const [materiels, setMateriels] = useState(EMPTY_MATERIELS)
    const [piezometer, setPiezometer] = useState({ ...piezometerStore })
    const [tmpState, setTmpState] = useState({
        diagnostics: [],
        actions: [],
        newSituations: [],
        formActions: [],
        piezometer: {},
        ...EMPTY_MATERIELS,
    })
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)
    const [openPopup, setOpenPopup] = useState(false)
    const [mails, setMails] = useState({
        mailContacts: [],
        mailContributors: [],
        mailCities: [],
        mailReceivers: [],
    })
    const [isPopupEmailOpen, setIsPopupEmailOpen] = useState(false)
    const [situationContributor, setSituationContributor] = useState(undefined)
    const [inputKeys, setInputKeys] = useState({ date: 0, hour: 0, endHour: 0 })

    const hourDebounce = useRef(undefined)
    const endHourDebounce = useRef(undefined)
    const eventRef = useRef(event)
    eventRef.current = event

    const isLast = isLastEvent(stationEvents, eventStore)
    const isUpdatable = isUpdatableEvent(eventStore, currentMaterielEventSituation)
    const disabled = { active: isEditMode, disabled: !isEditMode }

    const fetchMaterielsByEvent = (stationId, date) => dispatch(MaterielAction.fetchMaterielsByEvent(stationId, date)).then(json => setMateriels({
        centrals: json.centrals.map(el => new CentralDto(el)),
        powerSupplies: json.powerSupplies.map(el => new PowerSupplyDto(el)),
        sensors: json.sensors.map(el => new SensorDto(el)),
        sims: json.sims.map(el => new SimDto(el)),
        telecoms: json.telecoms.map(el => new TelecomDto(el)),
        variousMateriels: json.variousMateriels.map(el => new VariousMaterielDto(el)),
        equipments: json.equipments.map(el => new EquipmentWithMaterielsDto(el)),
        subscriptions: json.subscriptions.map(el => new SubscriptionDto(el)),
    }))

    const fetchDiagnosticsAndSolutionsByEvent = (stationId, date) => {
        dispatch(EventsAction.fetchDiagnosticsAndSolutions(stationId, date)).then(() => {
            const { code: eventCode, number } = eventRef.current
            if (eventCode && number) {
                dispatch(EventsAction.fetchPiezometerActions(eventCode, number))
            }
        })
    }

    useEffect(() => {
        if (isNew) {
            return
        }
        const interventions = eventPiezometerActions.map(intervention => ({
            intervention,
            diagnostic: eventPiezometerDiagnostics.find(d => d.codeDiagnostic === intervention.diagnosticCode),
            solution: eventPiezometerSolutions.find(s => s.codeSolution === intervention.solutionCode),
        }))
        const diagnosedInterventions = interventions.filter(({ diagnostic, solution }) => diagnostic && solution)
        setDiagnostics(uniqBy(diagnosedInterventions.map(({ diagnostic }) => diagnostic), 'codeDiagnostic'))
        setActions(diagnosedInterventions.map(({ diagnostic, solution }) => ({ ...solution, diagnosticId: diagnostic.codeDiagnostic })))
        setFormActions(interventions
            .filter(({ diagnostic, solution }) => solution && !diagnostic)
            .map(({ intervention, solution }) => ({ ...solution, value: intervention.value, materielId: intervention.materielId })))
    }, [eventPiezometerActions, isNew, eventPiezometerDiagnostics, eventPiezometerSolutions])

    useEffect(() => {
        if (!isNew) {
            setCauseInterventions(causeInterventionsStore.map(ci => ci.interventionId))
        }
    }, [causeInterventionsStore, isNew])

    useEffect(() => {
        if (!isNew) {
            dispatch(EventsAction.fetchEvent(STATION_TYPE_NAME.piezometry, id, code)).then(() => {
                const date = getDateWithHour(eventRef.current.date, eventRef.current.eventHour).valueOf()
                fetchMaterielsByEvent(id, date)
                fetchDiagnosticsAndSolutionsByEvent(id, date)
            })
            dispatch(EventsAction.fetchCauseIntervention(id, code))
            dispatch(EventsAction.fetchStationEvents(STATION_TYPE_NAME.piezometry, piezometerStore.id))
            dispatch(MaterielAction.fetchAllSituationByEvent(code, STATION_TYPE_NAME.piezometry, id)).then(jsonTab => setCurrentMaterielEventSituation(flatten([
                jsonTab[0].map(e => ({ ...e, materielId: e.idEquipment, materielCategory: 'equipment' })),
                jsonTab[1].map(c => ({ ...c, materielId: c.idCentral, materielCategory: 'central' })),
                jsonTab[2].map(s => ({ ...s, materielId: s.idSensor, materielCategory: 'sensor' })),
                jsonTab[3].map(ps => ({ ...ps, materielId: ps.idPowerSupply, materielCategory: 'powerSupply' })),
                jsonTab[4].map(s => ({ ...s, materielId: s.idSim, materielCategory: 'sim' })),
                jsonTab[5].map(t => ({ ...t, materielId: t.idTelecom, materielCategory: 'telecom' })),
                jsonTab[6].map(vm => ({ ...vm, materielId: vm.idVarious, materielCategory: 'variousMateriel' })),
                jsonTab[7].map(sub => ({ ...sub, materielId: sub.idSubscription, materielCategory: 'subscription' })),
            ])))
        } else {
            const date = getDateWithHour(event.date, event.eventHour).valueOf()
            fetchMaterielsByEvent(id, date)
            fetchDiagnosticsAndSolutionsByEvent(id, date)
        }

        dispatch(SubscriptionAction.fetchSimSubscriptionsLastSituations())
        dispatch(PiezometryAction.loadEventPanel(p => setProgress(p))).then(() => setDataLoaded(true))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => () => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
        dispatch(EventsAction.resetEvent())
    }, [dispatch])

    useEffect(() => {
        setEvent(prev => ({ ...prev, ...eventStore }))
        if (!isNew) {
            setIsEditMode(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventStore.id])

    useEffect(() => {
        if (!isNew) {
            setIsEditMode(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentMaterielEventSituation])

    useEffect(() => {
        setPiezometer({ ...piezometerStore })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [piezometerStore])

    useTitle(() => [{
        title: i18n[STATION_TYPE_NAME.piezometry],
        href: STATION_TYPE_NAME.piezometry,
    }, {
        title: `${piezometerStore.code} - ${piezometerStore.name}`,
        href: `station/${STATION_TYPE_NAME.piezometry}/${id}`,
    }, {
        title: i18n.journal,
        href: `station/${STATION_TYPE_NAME.piezometry}/${id}/event`,
    }, {
        title: isNew ? i18n.new : `${i18n.event} ${i18n.fromDate} ${getDate(eventStore.date)}`,
        href: `station/${STATION_TYPE_NAME.piezometry}/${id}/event/${code}`,
    }], [piezometerStore.code, piezometerStore.name, eventStore.date, id, code, isNew])

    const onChangeEvent = obj => setEvent(prev => ({ ...prev, ...obj }))

    const foundAction = constant => formActions.some(({ managementRule, value }) => managementRule === constant && value)

    const onSave = () => {
        if (event.eventType === EVENT_TYPES_CODES.NOT_DONE && isNil(event.causeNonRealisation)) {
            dispatch(ToastrAction.error(i18n.pleaseCompleteAllRequiredField))
            return
        }
        const { id: piezoId } = piezometerStore
        const eventToSave = [EVENT_TYPES_CODES.TO_MONITOR, EVENT_TYPES_CODES.TO_PLAN, EVENT_TYPES_CODES.NOT_DONE].includes(event.eventType) ? {
            ...event,
            eventDate: event.date,
            bankExport: '0',
        } : {
            ...event,
            eventDate: event.date,
        }
        const eventWithDiagnostic = {
            event: {
                ...eventToSave,
                code: piezoId,
                downloadData: foundAction(EVENT_ACTION.RECUPERATION_DES_DONNEES),
                transmissionTest: foundAction(EVENT_ACTION.TEST_TRANSMISSION),
                replaceDesiccant: foundAction(EVENT_ACTION.DESSICANT_REMPLACE),
                razstation: foundAction(EVENT_ACTION.REINITIALISATION_STATION) ? '1' : '0',
                firmwareUpdate: foundAction(EVENT_ACTION.FIRMWARE_MIS_A_JOUR),
                replaceORings: foundAction(EVENT_ACTION.JOINTS_TORIQUES_GRAISSES),
            },
            diagnostics: [
                ...actions.map(a => ({
                    piezometerCode: piezoId,
                    diagnosticCode: diagnostics.find(d => d.codeDiagnostic === a.diagnosticId).codeDiagnostic,
                    solutionCode: a.code,
                })),
                ...formActions.map(a => ({
                    ...a,
                    piezometerCode: piezoId,
                    solutionCode: a.code,
                })),
            ],
        }

        const interventionType = getInterventionType(eventToSave.eventType)

        const saveCauseAndSituations = eventCode => {
            const causesToSave = eventToSave.eventType === EVENT_TYPES_CODES.NOT_DONE ? [] : causeInterventions
            dispatch(EventsAction.createCauseIntervention(piezoId, eventCode, causesToSave.map(ci => ({
                interventionId: ci,
                interventionType,
                eventId: eventCode,
                stationId: piezoId,
            }))))
            const situations = newSituations.map(s => ({ ...s, eventCode, siteCode: piezoId, siteType: 1 }))
            dispatch(StationAction.updatePiezometer(piezometer))
            return dispatch(StationAction.addAllMaterielSituation(situations))
        }

        if (isNew) {
            dispatch(EventsAction.createPiezometryEventWithDiagnostic(piezoId, eventWithDiagnostic)).then(eventCode => {
                if (eventCode) {
                    saveCauseAndSituations(eventCode).then(() => dispatch(push(`/station/${STATION_TYPE_NAME.piezometry}/${piezoId}/event/${eventCode}`)))
                }
            })
            return
        }
        dispatch(EventsAction.updatePiezometryEventWithDiagnostic(piezoId, code, eventWithDiagnostic)).then(eventCode => {
            if (eventCode) {
                saveCauseAndSituations(eventCode)
            }
        })
    }

    const onDelete = () => dispatch(EventsAction.deleteEvent(STATION_TYPE_NAME.piezometry, id, code))
        .then(() => dispatch(push(`/station/${STATION_TYPE_NAME.piezometry}/${id}/event`)))

    const handleShare = socialNetwork => {
        switch (socialNetwork.id) {
            case 'facebook':
                dispatch(SieauAction.setPopup({
                    id: uuidv4(),
                    header: i18n.sharingConfirmation,
                    actions: (
                        <div>
                            <a className='waves-effect waves-teal btn-flat modal-close'>{i18n.close}</a>
                            <a
                                className='waves-effect waves-teal btn-flat modal-close btn font-white'
                                onClick={() => dispatch(EventsAction.postFacebook(STATION_TYPE_NAME.piezometry, eventStore.code, eventStore.id))}
                            >
                                {i18n.validate}
                            </a>
                        </div>
                    ),
                }))
                break
            case 'email':
                setIsPopupEmailOpen(true)
                break
            default:
        }
    }

    const getSharedTypes = () => {
        const types = [{
            id: 'email',
            onClick: handleShare,
            icon: 'email',
            label: i18n.email,
        }]
        const idContributors = (piezometerStore.contributors || []).map(c => c.idContributor)
        const fbContributor = contributors.find(c => idContributors.includes(c.id) && c.name.toLowerCase() === 'facebook')
        if (fbContributor) {
            return [{
                id: 'facebook',
                onClick: handleShare,
                img: 'assets/pictures/socialNetworks/logo_facebook.png',
                label: 'Facebook',
            }, ...types]
        }
        return types
    }

    const onCancel = () => {
        const date = getDateWithHour(eventStore.date, eventStore.eventHour).valueOf()
        setEvent({ ...eventStore })
        setCauseInterventions(causeInterventionsStore.map(ci => ci.interventionId))
        setNewSituations([])
        fetchMaterielsByEvent(id, date)
        fetchDiagnosticsAndSolutionsByEvent(id, date)
        setIsEditMode(false)
    }

    useActions(() => {
        if (getUser().consultant === '1') {
            return {}
        }
        if (isNew) {
            return { save: onSave }
        }
        if (isEditMode) {
            return {
                delete: onDelete,
                save: () => {
                    setIsEditMode(false)
                    onSave()
                },
                cancel: onCancel,
            }
        }
        if (isLast || isUpdatable) {
            return {
                edit: () => setIsEditMode(true),
                delete: onDelete,
                share: getSharedTypes(),
                other: !eventStore.closeDate ? {
                    other: (
                        <Other
                            className='clickable'
                            tooltip={i18n.closeEvent}
                            icon='lock'
                            onClick={() => dispatch(EventsAction.updateEvent(STATION_TYPE_NAME.piezometry, event.stationId, event.number, { ...event, closeDate: moment().valueOf() }))}
                        />
                    ),
                } : undefined,
            }
        }
        return { share: getSharedTypes() }
    }, [isNew, isEditMode, isLast, isUpdatable, event, eventStore, piezometer, diagnostics, actions, formActions, causeInterventions, newSituations, id, code])

    const getBooleanChoiceWithAction = (label, actionConstant, materielId, disabledProps) => {
        const action = eventPiezometerSolutions.find(s => s.managementRule === actionConstant)
        const predicate = materielId ? a => a.managementRule === actionConstant && a.materielId === materielId : a => a.managementRule === actionConstant
        const formAction = formActions.find(predicate)
        const onSetFormAction = value => {
            if (hasValue(value)) {
                setFormActions(prev => uniqBy([{ ...action, materielId, value }, ...prev], a => a.managementRule + a.materielId))
            } else {
                const removePredicate = materielId ? a => a.managementRule !== actionConstant || a.materielId !== materielId : a => a.managementRule !== actionConstant
                setFormActions(prev => prev.filter(removePredicate))
            }
        }
        return (
            <tr>
                <td>{label}</td>
                <td className='padding-left-2'>
                    <Checkbox
                        checked={formAction && formAction.value === 1}
                        onChange={v => onSetFormAction(v ? 1 : null)}
                        {...disabledProps}
                    />
                </td>
                <td className='padding-left-2'>
                    <Checkbox
                        checked={formAction && formAction.value === 0}
                        onChange={v => onSetFormAction(v ? 0 : null)}
                        {...disabledProps}
                    />
                </td>
            </tr>
        )
    }

    const getOldBooleanChoice = (label, key) => (
        <tr>
            <td>{label}</td>
            <td className='padding-left-2'>
                <Checkbox
                    checked={event[key] === '1'}
                    onChange={v => onChangeEvent({ [key]: v ? '1' : null })}
                    {...disabled}
                    data-cy={label}
                />
            </td>
            <td className='padding-left-2'>
                <Checkbox
                    checked={event[key] === '0'}
                    onChange={v => onChangeEvent({ [key]: v ? '0' : null })}
                    {...disabled}
                    data-cy='falseCheckBox'
                />
            </td>
        </tr>
    )

    const setFormAction = (actionConstant, value, materielId, toSet = true) => {
        if (toSet) {
            const action = eventPiezometerSolutions.find(s => s.managementRule === actionConstant)
            if (action) {
                const withValue = removeNullKeys({ ...action, value, materielId })
                setFormActions(prev => uniqBy([withValue, ...prev], a => a.managementRule + a.materielId))
            }
            return
        }
        const predicate = materielId ? a => a.managementRule !== actionConstant || a.materielId !== materielId : a => a.managementRule !== actionConstant
        setFormActions(prev => prev.filter(predicate))
    }

    const getActionValue = (actionConstant, materielId) => {
        const predicate = materielId ? a => a.managementRule === actionConstant && a.materielId === materielId : a => a.managementRule === actionConstant
        const action = formActions.find(predicate)
        return action ? action.value : null
    }

    const getLastReplacementDate = (managementRule, materielId) => {
        const rules = eventPiezometerReplacementAction.filter(a => a.action === managementRule && a.materielId === materielId)
        if (rules.length) {
            return getFullDate(max(rules.map(a => getDateWithHour(a.date, a.hour).valueOf())))
        }
        return i18n.never
    }

    const getLastDepthMeasure = () => {
        const rules = eventPiezometerReplacementAction.filter(a => a.action === EVENT_ACTION.MESURE_PROFONDEUR_STATION)
        if (rules.length) {
            const eventDate = getDateWithHour(event.date, event.eventHour)
            const measureDate = max(rules.map(a => getDateWithHour(a.date, a.hour).valueOf()).filter(date => date < eventDate))
            const foundEvent = stationEvents.find(({ date, eventHour }) => getDateWithHour(date, eventHour).valueOf() === measureDate)
            if (foundEvent) {
                const action = eventAllPiezometerActions.filter(({ solutionCode }) => solutionCode === -109).find(({ eventCode }) => eventCode === foundEvent.id)
                if (action) {
                    return `${action.value}m ${i18n.onDate} ${getFullDate(measureDate)}`
                }
            }
        }
        return i18n.never
    }

    const createActionNewLevel = (nc, newNc) => {
        onChangeEvent({ newNc })
        setFormAction(EVENT_ACTION.REMPLACEMENT_MESURE_NIVEAU, newNc, null, hasValue(newNc) && hasValue(nc) && newNc !== nc)
    }

    const openDiagnosticPopin = newStep => {
        const filteredEvents = stationEvents.filter(e => e.eventType === EVENT_TYPES_CODES.PREVENTIVE || e.eventType === EVENT_TYPES_CODES.CURATIVE)
        if (!isLastEvent(filteredEvents, event)) {
            dispatch(ToastrAction.warning(i18n.functionnalityBlockedEventTooOld))
            return
        }
        setOpenPopup(true)
        setStep(newStep)
        setTmpState(prev => ({
            ...prev,
            diagnostics,
            actions,
            formActions,
            newSituations,
            piezometer,
            ...materiels,
        }))
    }

    const getInterventions = () => {
        const interventions = orderBy(uniqBy(diagnostics, 'codeDiagnostic'), 'codeDiagnostic').map(d => ({
            diagnostic: d,
            action: actions.filter(a => a.diagnosticId === d.codeDiagnostic),
        }))
        const actionsList = isEditMode ? [{
            icon: 'add',
            onClick: () => openDiagnosticPopin(STEPS.DIAGNOSTIC),
            color: whiteColor,
        }] : []
        const situations = isNew ? newSituations : [...currentMaterielEventSituation, ...newSituations]
        return (
            <Card>
                <CardTitle title={i18n.intervention} color={darkBlue} actions={actionsList} />
                <CardContent>
                    {interventions.length ? (
                        <Stack spacing={1}>
                            {interventions.map(i => (
                                <Grid container key={i.diagnostic.codeDiagnostic}>
                                    <Grid size={12}>
                                        <ElementCard
                                            icon='report_problem'
                                            color='red'
                                            {...(isEditMode ? {
                                                className: 'clickable',
                                                onClick: () => openDiagnosticPopin(STEPS.DIAGNOSTIC),
                                            } : {})}
                                        >
                                            <Typography variant={'h6'}>{i.diagnostic.description}</Typography>
                                        </ElementCard>
                                    </Grid>
                                    <Grid size={10} offset={2}>
                                        {i.action.map(a => (
                                            <ElementCard
                                                key={a.code}
                                                icon='build'
                                                color='green'
                                                {...(isEditMode ? {
                                                    className: 'clickable',
                                                    onClick: () => openDiagnosticPopin(STEPS.ACTION),
                                                } : {})}
                                            >
                                                <Typography variant={'h6'}>{a.description}</Typography>
                                            </ElementCard>
                                        ))}
                                    </Grid>
                                </Grid>
                            ))}
                            {situations.map(({ materielCategory: category, materielId, statusCode }, index) => {
                                const materiel = materielsByCategory[category]?.materiels?.find(m => m.id === materielId)
                                const materielType = materielsByCategory[category]?.types?.find(t => t.materielType === materiel.materielType)
                                const matState = materielStates.find(s => s.code === statusCode) || {}
                                const matStateIcon = getMaterialStateIcon(matState.code)
                                return (
                                    <ElementCard
                                        key={`${category}-${materielId}-${index}`}
                                        icon={matStateIcon.icon}
                                        iconColor={matStateIcon.color}
                                        color='white'
                                        style={{ color: statusCode === 1 ? 'dodgerBlue' : 'red' }}
                                    >
                                        {`${upperFirst(matState.label)}: ${upperFirst(category)} ${materielType ? `${materielType.name} - ` : ''}${materiel.numLine || materiel.imei || materiel.serialNumber || ''}`}
                                    </ElementCard>
                                )
                            })}
                        </Stack>
                    ) : (
                        <Stack alignItems='center'>
                            <Box>
                                <ReportProblemIcon sx={{ fontSize: '4rem' }} />
                                <BuildIcon sx={{ fontSize: '4rem' }} />
                            </Box>
                            <Typography>{i18n.noneDiagnosticActionSelect}</Typography>
                        </Stack>
                    )}
                </CardContent>
            </Card>
        )
    }

    const onChangeEventDate = v => onChangeDate(
        v,
        v2 => {
            const resolvedDate = v2 ?? moment().valueOf()
            const newDate = getDateWithHour(resolvedDate, event.eventHour)?.valueOf()
            setEvent(prev => (prev.eventType === EVENT_TYPES_CODES.COMMENT && v2 !== undefined ? {
                ...prev,
                date: resolvedDate,
                endDate: resolvedDate,
            } : {
                ...prev,
                date: resolvedDate,
            }))
            const updatedSituations = newSituations.map(s => ({ ...s, situationDate: newDate }))
            setNewSituations(updatedSituations)
            setTmpState(prev => ({ ...prev, newSituations: updatedSituations }))
            if (v2 === undefined) {
                setInputKeys(prev => ({ ...prev, date: prev.date + 1 }))
            }
            if (newDate) {
                fetchMaterielsByEvent(piezometerStore.id, newDate)
            }
        },
    )

    const commitEventHour = raw => {
        if (!event.date && !`${raw ?? ''}`.replace(/\D/g, '')) {
            return
        }
        onChangeHour(
            formatHourInput(raw),
            v2 => {
                setEvent(prev => ({ ...prev, date: v2, eventHour: v2 }))
                const updatedSituations = newSituations.map(s => ({ ...s, situationDate: v2 }))
                setNewSituations(updatedSituations)
                setTmpState(prev => ({ ...prev, newSituations: updatedSituations }))
                setInputKeys(prev => ({ ...prev, hour: prev.hour + 1 }))
                fetchMaterielsByEvent(piezometerStore.id, v2)
            },
            undefined,
            safeBaseDate(event.date),
        )
    }

    const onChangeEventHour = v => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        hourDebounce.current = setTimeout(() => commitEventHour(v), 1000)
    }

    const onBlurEventHour = raw => {
        if (hourDebounce.current) {
            clearTimeout(hourDebounce.current)
        }
        commitEventHour(raw)
    }

    const commitEndHour = raw => {
        onChangeHour(
            formatHourInput(raw),
            v2 => {
                setEvent(prev => ({ ...prev, endDate: v2 }))
                setInputKeys(prev => ({ ...prev, endHour: prev.endHour + 1 }))
            },
            { min: event.date },
            safeBaseDate(event.endDate),
        )
    }

    const onChangeEndHour = v => {
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
        endHourDebounce.current = setTimeout(() => commitEndHour(v), 500)
    }

    const onBlurEndHour = raw => {
        if (endHourDebounce.current) {
            clearTimeout(endHourDebounce.current)
        }
        commitEndHour(raw)
    }

    const getCampaigns = () => {
        const campaignsId = piezometryCampaignStations.filter(({ stationId }) => stationId === piezometerStore.id).map(({ campaignId }) => campaignId)
        return uniq(campaignsId.map(campaignId => piezometryCampaigns.find(({ id: campId }) => campaignId === campId)).filter(c => !!c))
    }

    const getEventDateCard = (withCampaign = false, disabledOverride = disabled) => {
        const { eventType, campaignCode, date, eventHour, endDate } = event
        const causeInterventionList = getSandreList(sandreCodes, `CAUSE_INTERVENTION.${getInterventionType(eventType)}`)
        const { options: campaignOptions, optionsGroups: campaignGroups } = buildCampaignGroups(getCampaigns(), sandreCodes)
        return (
            <Grid container spacing={1}>
                <Grid size={4}>
                    <Input
                        key={`eventDate-${inputKeys.date}`}
                        title={i18n.date}
                        value={getDate(date)}
                        onChange={onChangeEventDate}
                        {...disabledOverride}
                        data-cy='dateEvent'
                    />
                </Grid>
                <Grid size={4}>
                    <Input
                        key={`eventHour-${date ? '1' : '0'}-${inputKeys.hour}`}
                        title={i18n.hour}
                        value={date ? getHour(eventHour) : ''}
                        onChange={onChangeEventHour}
                        otherInputProps={{ onBlur: e => onBlurEventHour(e.target.value) }}
                        {...disabledOverride}
                        data-cy='hourEvent'
                    />
                </Grid>
                {withCampaign ? (
                    <Grid size={4}>
                        <SuperMultiAutocomplete
                            label={i18n.campaign}
                            values={campaignCode}
                            options={campaignOptions}
                            optionsGroups={campaignGroups}
                            noSort
                            onChange={campaignId => onChangeEvent({ campaignCode: campaignId })}
                            {...disabledOverride}
                        />
                    </Grid>
                ) : <Grid offset={3} />}
                <Grid size={4}>
                    <Input
                        title={i18n.endDate}
                        value={getDate(endDate)}
                        onChange={v => onChangeDate(v, v2 => onChangeEvent({ endDate: v2 }), { min: date })}
                        {...disabledOverride}
                        data-cy='endDateEvent'
                    />
                </Grid>
                <Grid size={4}>
                    <Input
                        key={`endHour-${inputKeys.endHour}`}
                        title={i18n.hour}
                        value={getHour(endDate)}
                        onChange={onChangeEndHour}
                        otherInputProps={{ onBlur: e => onBlurEndHour(e.target.value) }}
                        {...disabledOverride}
                        data-cy='endHourEvent'
                    />
                </Grid>
                <Grid size={8}>
                    {eventType === EVENT_TYPES_CODES.NOT_DONE ? (
                        <Select
                            label={i18n.causeNonRealisation}
                            options={getSandreList(sandreCodes, SANDRE.CAUSE_NON_REALISATION)}
                            value={event.causeNonRealisation}
                            onChange={v => onChangeEvent({ causeNonRealisation: v })}
                            keyValue='code'
                            keyLabel='name'
                            integerValue
                            obligatory
                            {...disabledOverride}
                        />
                    ) : (
                        <SuperMultiAutocomplete
                            label={i18n.causeIntervention}
                            options={causeInterventionList}
                            onChange={list => setCauseInterventions(list)}
                            values={causeInterventions}
                            {...disabledOverride}
                            multiple
                            limit={4}
                            noSort
                            keyValue='code'
                            keyLabel='name'
                            data-cy='causeIntervention'
                        />
                    )}
                </Grid>
            </Grid>
        )
    }

    const getMaterielCards = (list, renderCard) => (
        <Grid size={12}>
            <Stack spacing={1}>
                {(list.length ? list : [{}]).map(renderCard)}
            </Stack>
        </Grid>
    )

    const getPreventiveCurativeForm = preventive => {
        const { centrals, sensors, telecoms, equipments } = materiels
        const situation = [...currentMaterielEventSituation, ...newSituations]
        const hasSomeMateriel = !![...centrals, ...sensors, ...telecoms, ...equipments].length
        const onChangeTestSignal = (checked, telecomId) => {
            if (checked) {
                setTestSignal(prev => [...prev, telecomId])
                return
            }
            setTestSignal(prev => prev.filter(signalId => signalId !== telecomId))
            setFormActions(prev => prev.filter(a => !a.managementRule.includes('TEST_SIGNAL_')))
        }
        return (
            <Grid container justifyContent={'center'}>
                <Grid size={8}>
                    <Card>
                        <CardTitle title={i18n.event} color={darkBlue} />
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    {getEventDateCard(true)}
                                </Grid>
                                {!preventive && (
                                    <Grid size={12}>
                                        {getInterventions()}
                                    </Grid>
                                )}
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <table>
                                        <tbody>
                                            {getYesOrNo()}
                                            {getBooleanChoiceWithAction(i18n.downloadData, 'RECUPERATION_DES_DONNEES', undefined, disabled)}
                                        </tbody>
                                    </table>
                                </Grid>
                                {(!!telecoms.length || !hasSomeMateriel) && getMaterielCards(telecoms, mat => (
                                    <EventTelecomCard
                                        key={`telecom-${mat.id}`}
                                        telecom={mat}
                                        hasSignalTestAction={testSignal.includes(mat.id)}
                                        disabled={disabled}
                                        formActions={formActions}
                                        lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_TELETRANSMISSION, mat.id)}
                                        setFormAction={setFormAction}
                                        onChangeTestSignal={v => onChangeTestSignal(v, mat.id)}
                                        getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                    />
                                ))}
                                {(!!sensors.length || !hasSomeMateriel) && getMaterielCards(sensors, mat => (
                                    <EventSensorCard
                                        key={`sensor-${mat.id}`}
                                        sensor={mat}
                                        formActions={formActions}
                                        disabled={disabled}
                                        lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_CAPTEUR, mat.id)}
                                        setFormAction={setFormAction}
                                        getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                    />
                                ))}
                                {(!!centrals.length || !hasSomeMateriel) && getMaterielCards(centrals, mat => (
                                    <EventCentralCard
                                        key={`central-${mat.id}`}
                                        central={mat}
                                        formActions={formActions}
                                        disabled={disabled}
                                        lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_CENTRALE, mat.id)}
                                        setFormAction={setFormAction}
                                        getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                    />
                                ))}
                                {(!!equipments.length || !hasSomeMateriel) && getMaterielCards(equipments, mat => mat.equipment ? (
                                    <EventEquipmentCard
                                        key={`equipment-${mat.equipment.id}`}
                                        materiels={mat}
                                        testSignal={testSignal}
                                        disabled={disabled}
                                        formActions={formActions}
                                        getLastReplacementDate={getLastReplacementDate}
                                        setFormAction={setFormAction}
                                        onChangeTestSignal={onChangeTestSignal}
                                        getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                    />
                                ) : null)}
                                <Grid size={12}>
                                    <Card>
                                        <CardTitle title={i18n.station} color={darkBlue} />
                                        <CardContent>
                                            <Grid container spacing={1} padding={1}>
                                                <Grid size={8}>
                                                    <NumberField
                                                        value={event.ns}
                                                        title={i18n.staticLevelMeasure}
                                                        floatValue
                                                        onChange={v => onChangeEvent({ ns: v })}
                                                        {...disabled}
                                                    />
                                                    <NumberField
                                                        value={event.nc}
                                                        title={i18n.sensorInstantLevel}
                                                        floatValue
                                                        onChange={v => onChangeEvent({ nc: v })}
                                                        {...disabled}
                                                    />
                                                    {hasValue(event.ns) && hasValue(event.nc) ? `${i18n.difference} : ${round(event.ns - event.nc, 10)}` : ''}
                                                </Grid>
                                                <Grid size={3} offset={1}>
                                                    <Checkbox
                                                        label={i18n.calibrationUpdate}
                                                        checked={event.calibrationUpdate}
                                                        onChange={v => onChangeEvent({ calibrationUpdate: v })}
                                                        active={disabled.active}
                                                        disabled={disabled.disabled || (hasValue(event.ns) && hasValue(event.nc) ? round(event.ns - event.nc, 10) === 0 : true)}
                                                    />
                                                    <Typography variant={'h6'}>{`${i18n.lastLevelMeasure} : ${getLastDepthMeasure()}`}</Typography>
                                                </Grid>
                                                <Grid size={8}>
                                                    <NumberField
                                                        value={getActionValue(EVENT_ACTION.MESURE_PROFONDEUR_STATION)}
                                                        title={i18n.totalDepth}
                                                        floatValue
                                                        onChange={v => {
                                                            setFormAction(EVENT_ACTION.MESURE_PROFONDEUR_STATION, v, null, hasValue(v))
                                                            setPiezometer(prev => ({
                                                                ...prev,
                                                                link_work: [{
                                                                    ...prev.link_work?.[0] || {},
                                                                    idStation: prev.id,
                                                                    workDepth: v,
                                                                }],
                                                            }))
                                                        }}
                                                        {...disabled}
                                                    />
                                                    <Typography variant={'h6'}>
                                                        {`${i18n.workDepth} : ${piezometerStore.link_work.length && piezometerStore.link_work[0].workDepth ? `${piezometerStore.link_work[0].workDepth}m` : i18n.never}`}
                                                    </Typography>
                                                </Grid>
                                                {!!situation.find(s => s.materielCategory === 'sensor' && s.statusCode === 1) && (
                                                    <Grid size={12}>
                                                        <Typography>{i18n.afterSensorChange}</Typography>
                                                        <fieldset>
                                                            <NumberField
                                                                value={event.newNc}
                                                                title={i18n.newSensorInstantLevel}
                                                                floatValue
                                                                onChange={v => createActionNewLevel(event.nc, v)}
                                                                {...disabled}
                                                            />
                                                        </fieldset>
                                                    </Grid>
                                                )}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <table>
                                                        <tbody>
                                                            {getYesOrNo()}
                                                            {getBooleanChoiceWithAction(i18n.replaceORings, 'JOINTS_TORIQUES_GRAISSES', undefined, disabled)}
                                                            {getBooleanChoiceWithAction(i18n.calibrateDateAndHour, 'DATE_HEURE_RECALIBREES', undefined, disabled)}
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid size={12}>
                                    <Card>
                                        <CardTitle title={i18n.comment} color={darkBlue} />
                                        <CardContent>
                                            <Textarea value={event.comment} onChange={v => onChangeEvent({ comment: v })} {...disabled} />
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid size={12}>
                                    <Card>
                                        <CardTitle title={i18n.various} color={darkBlue}/>
                                        <CardContent>
                                            <Grid container spacing={1}>
                                                <Grid size={12}>
                                                    <Select
                                                        value={event.contactCode}
                                                        label={i18n.author}
                                                        options={contacts}
                                                        keyValue='id'
                                                        displayWithCode
                                                        onChange={v => onChangeEvent({ contactCode: v })}
                                                        {...disabled}
                                                    />
                                                </Grid>
                                                <Grid size={6}>
                                                    <table>
                                                        <tbody>
                                                            {getYesOrNo()}
                                                            {getOldBooleanChoice(i18n.bankExport, 'bankExport')}
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                                <Grid size={6}>
                                                    <table>
                                                        <tbody>
                                                            {getYesOrNo()}
                                                            {getOldBooleanChoice(i18n.displayGraph, 'graph')}
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {preventive && (
                                    <Grid size={12}>
                                        {getInterventions()}
                                    </Grid>
                                )}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        )
    }

    const onChangeEventType = type => {
        setEvent(prev => ({
            ...prev,
            eventType: type,
            eventDate: moment().valueOf(),
            causeNonRealisation: type === EVENT_TYPES_CODES.NOT_DONE ? prev.causeNonRealisation : undefined,
        }))
        if (type === EVENT_TYPES_CODES.NOT_DONE || getInterventionType(event.eventType) !== getInterventionType(type)) {
            setCauseInterventions([])
        }
    }

    const getToPlanToMonitorCommentForm = comment => (
        <Grid container justifyContent={'center'}>
            <Grid size={8}>
                <Card>
                    <CardTitle title={i18n.event} color={darkBlue} />
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                {getEventDateCard(true)}
                            </Grid>
                            <Grid size={12}>
                                <Card>
                                    <CardTitle title={i18n.comment} color={darkBlue} />
                                    <CardContent>
                                        <Textarea
                                            value={event.comment}
                                            onChange={v => onChangeEvent({ comment: v })}
                                            {...disabled}
                                            data-cy='comment'
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid size={12}>
                                <Card>
                                    <CardTitle title={i18n.various} color={darkBlue}/>
                                    <CardContent>
                                        <Grid container spacing={1}>
                                            <Grid size={12}>
                                                <Select
                                                    value={event.contactCode}
                                                    label={i18n.author}
                                                    options={contacts}
                                                    keyValue='id'
                                                    displayWithCode
                                                    onChange={v => onChangeEvent({ contactCode: v })}
                                                    {...disabled}
                                                    data-cy='contactCode'
                                                />
                                            </Grid>
                                            {comment && (
                                                <Grid size={6}>
                                                    <table>
                                                        <tbody>
                                                            {getYesOrNo()}
                                                            {getOldBooleanChoice(i18n.bankExport, 'bankExport')}
                                                        </tbody>
                                                    </table>
                                                </Grid>
                                            )}
                                            <Grid size={6}>
                                                <table>
                                                    <tbody>
                                                        {getYesOrNo()}
                                                        {getOldBooleanChoice(i18n.displayGraph, 'graph')}
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )

    const onChangeDiagnostic = diagnostic => {
        if (tmpState.diagnostics.find(a => a.codeDiagnostic === diagnostic.codeDiagnostic)) {
            setTmpState(prev => ({
                ...prev,
                diagnostics: prev.diagnostics.filter(sa => sa.codeDiagnostic !== diagnostic.codeDiagnostic),
                actions: prev.actions.filter(a => a.diagnosticId !== diagnostic.codeDiagnostic),
            }))
            return
        }
        setTmpState(prev => ({ ...prev, diagnostics: [...prev.diagnostics, diagnostic] }))
    }

    const getNewStep = ({ materialChange }) => {
        if (materialChange === '1') {
            return STEPS.MATERIEL_ADD
        }
        if (materialChange === '2') {
            return STEPS.LANDMARK_ADD
        }
        return STEPS.ACTION
    }

    const onChangeAction = action => {
        const diagnostic = tmpState.diagnostics[interventionIndex]
        const actionInState = tmpState.actions.find(a => a.code === action.code && a.diagnosticId === diagnostic.codeDiagnostic)
        if (actionInState) {
            const actionByIntervention = tmpState.actions.filter(sa => sa.code !== action.code && sa.diagnosticId === diagnostic.codeDiagnostic)
            const actionRest = tmpState.actions.filter(sr => sr.diagnosticId !== diagnostic.codeDiagnostic)
            setTmpState(prev => ({ ...prev, actions: [...actionByIntervention, ...actionRest] }))
            return
        }
        setStep(getNewStep(action))
        setTmpState(prev => ({ ...prev, actions: [action, ...prev.actions] }))
    }

    const materielAfterRemove = (category, materielId) => {
        if (category === 'equipment') {
            return { equipments: materiels.equipments.filter(m => m.equipment.id !== materielId) }
        }
        return { [getMaterielPlural(category)]: materiels[getMaterielPlural(category)].filter(m => m.id !== materielId) }
    }

    const undoMateriel = (category, sitCurrentMat = {}, sitNextMat = {}) => {
        const updatedMateriels = category === 'equipment' ? {
            equipments: [
                ...materiels.equipments.filter(m => m.equipment.id !== sitNextMat.materielId),
                stationEquipment.find(e => e.equipment.id === sitCurrentMat.materielId),
            ].filter(e => !!e),
        } : {
            [getMaterielPlural(category)]: [
                ...materiels[getMaterielPlural(category)].filter(m => m.id !== sitNextMat.materielId),
                materielsByCategory[category]?.materiels?.find(m => m.id === sitCurrentMat.materielId),
            ].filter(e => !!e),
        }
        setTmpState(prev => ({
            ...prev,
            ...updatedMateriels,
            formActions: prev.formActions.filter(a => (a.materielId !== sitCurrentMat.materielId && a.materielId !== sitNextMat.materielId) || category !== getActionMaterielType(a.managementRule)),
            newSituations: prev.newSituations.filter(s => (s.materielId !== sitCurrentMat.materielId && s.materielId !== sitNextMat.materielId) || category !== s.materielCategory),
        }))
    }

    const getStationMateriels = (lastAssignment, category) => {
        if (!lastAssignment) {
            return null
        }
        if (category === 'equipment') {
            return (stationEquipment.find(m => m.equipment.id === lastAssignment.materielId) || {}).equipment
        }
        return materielsByCategory[category].station.find(m => m.id === lastAssignment.materielId)
    }

    const getCurrentMateriels = ({ materielCategory: category, materielId }) => {
        if (category === 'equipment') {
            return (tmpState.equipments.find(m => m.equipment.id === materielId) || {}).equipment
        }
        return tmpState[getMaterielPlural(category)].find(m => m.id === materielId)
    }

    const getDiagnosticActionHeader = (diagnostic, action) => (
        <Grid container spacing={1}>
            <Grid size={6}>
                <ElementCard
                    icon='report_problem'
                    color='red'
                    className='clickable'
                    onClick={() => setStep(STEPS.DIAGNOSTIC)}
                >
                    <Typography variant={'h6'}>{diagnostic.description}</Typography>
                </ElementCard>
            </Grid>
            <Grid size={6}>
                <ElementCard
                    icon='build'
                    color='green'
                    className='clickable'
                    onClick={() => setStep(STEPS.ACTION)}
                >
                    <Typography variant={'h6'}>{action.description}</Typography>
                </ElementCard>
            </Grid>
        </Grid>
    )

    const getMaterielCategoryChoice = () => {
        const diagnostic = tmpState.diagnostics[interventionIndex]
        const action = tmpState.actions.find(d => d.diagnosticId === diagnostic.codeDiagnostic)
        const materielsCards = materielTypes.filter(({ link }) => link !== 'sim').map(({ link }) => {
            const assignments = materielsByCategory[link]?.assignments
            const lastAssignments = assignments?.length ? assignments.filter(a => !a.situationEndDate) : []
            const mat = lastAssignments.map(lastAssignment => {
                const materiel = getStationMateriels(lastAssignment, link)
                const materielType = materiel && materiel.materielType ? materielsByCategory[link]?.types?.find(t => t.materielType === materiel.materielType) : {}
                return (
                    <MaterielCard
                        key={`${link}-${lastAssignment.materielId}`}
                        newSituations={tmpState.newSituations}
                        materielCategory={link}
                        materielTypeName={materielType.name || ''}
                        materiel={materiel}
                        situationDate={getDate(lastAssignment.situationDate)}
                        undoMateriel={undoMateriel}
                        actions={{
                            remove: () => {
                                setStep(STEPS.MATERIEL_SITUATION_OF_LAST)
                                setSelectedMateriel(materiel.id)
                                setMaterielCategory(link)
                                setSelectedType(undefined)
                                setTmpState(prev => ({
                                    ...prev,
                                    ...materielAfterRemove(link, materiel.id),
                                    formActions: prev.formActions.filter(a => a.materielId !== materiel.id || link !== getActionMaterielType(a.managementRule)),
                                }))
                            },
                            replace: () => {
                                setStep(STEPS.MATERIEL_CHOICE)
                                setMaterielCategory(link)
                                setSelectedType(undefined)
                                setSelectedMateriel(materiel.id)
                                setTmpState(prev => ({
                                    ...prev,
                                    formActions: prev.formActions.filter(a => a.materielId !== materiel.id || link !== getActionMaterielType(a.managementRule)),
                                }))
                            },
                        }}
                    />
                )
            })

            const newMat = tmpState.newSituations.filter(s => s.materielCategory === link && s.statusCode === 1 && !s.previousMateriel).map(sit => {
                const materiel = getCurrentMateriels(sit)
                const materielType = materiel && materiel.materielType ? materielsByCategory[link]?.types?.find(t => t.materielType === materiel.materielType) : {}
                return (
                    <MaterielCard
                        key={`new-${link}-${sit.materielId}`}
                        newSituations={tmpState.newSituations}
                        materielCategory={link}
                        materielTypeName={materielType.name}
                        materiel={materiel}
                        situationDate={getDate(sit.situationDate)}
                        undoMateriel={undoMateriel}
                        actions={{
                            cancel: () => setTmpState(prev => ({
                                ...prev,
                                ...materielAfterRemove(link, materiel.id),
                                formActions: prev.formActions.filter(a => a.materielId !== materiel.id || link !== getActionMaterielType(a.managementRule)),
                                newSituations: prev.newSituations.filter(s => s.materielId !== materiel.id),
                            })),
                        }}
                    />
                )
            })
            return [...mat, ...newMat]
        })

        return (
            <Box>
                {getDiagnosticActionHeader(diagnostic, action)}
                <Stack direction='row' alignItems='center' spacing={1} paddingLeft={1} paddingTop={1}>
                    <TrendingFlatIcon />
                    <Typography variant={'h6'}>{`${i18n.allStationMaterial} ${i18n.choiceNewMaterial}`}</Typography>
                </Stack>
                <Stack spacing={1} sx={{ maxHeight: '40%' }}>
                    {flatten(materielsCards)}
                    <Card>
                        <CardContent>
                            <Stack
                                onClick={() => setStep(STEPS.MATERIEL_CATEGORY_CHOICE)}
                                alignItems='center'
                                sx={{ cursor: 'pointer' }}
                            >
                                <NoteAddIcon fontSize={'large'} />
                                <Typography>{i18n.add}</Typography>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </Box>
        )
    }

    const getMaterielChoice = () => {
        const { diagnostics: tmpDiagnostics, actions: tmpActions, newSituations: tmpNewSituations } = tmpState
        const diagnostic = tmpDiagnostics[interventionIndex]
        const action = tmpActions.find(d => d.diagnosticId === diagnostic.codeDiagnostic)

        const inStockLastSituations = materielsByCategory[materielCategory]?.lastSituations.filter(s => s.statusCode === 2)
        const allMateriels = materielsByCategory[materielCategory]?.materiels
        const inStockMateriels = inStockLastSituations?.map(s => allMateriels.find(m => m.id === s.materielId)).filter(m => !!m)
        const availableTypes = materielsByCategory[materielCategory]?.types?.map(t => ({
            ...t,
            code: t.materielType,
            materielCount: inStockMateriels?.filter(m => m.materielType === t.materielType).length,
        })).filter(t => t.materielCount > 0)
        const materielTypesWithCount = availableTypes?.map(t => ({
            ...t,
            name: `${t.name} (${t.materielCount} ${i18n[getMaterielPlural(materielCategory)]})`,
        }))
        const type = selectedType || (availableTypes?.length ? availableTypes?.[0]?.materielType : null)

        const assignments = materielsByCategory[materielCategory]?.assignments
        const lastAssignment = assignments?.length ? assignments.find(a => !a.situationEndDate && a.materielId === selectedMateriel) : null
        const materiel = getStationMateriels(lastAssignment, materielCategory)

        const onSelectNewMateriel = mat => {
            if (materielCategory === 'equipment') {
                dispatch(EquipmentAction.fetchEquipment(mat.equipmentId)).then(json => setTmpState(prev => ({
                    ...prev,
                    equipments: [
                        ...materiels?.equipments.filter(m => !lastAssignment || m.equipment.equipmentId !== lastAssignment.materielId),
                        new EquipmentWithMaterielsDto(json),
                    ],
                })))
            }
            const newMat = materielCategory === 'equipment' ? {} : {
                [getMaterielPlural(materielCategory)]: [
                    ...materiels?.[getMaterielPlural(materielCategory)].filter(m => !lastAssignment || m.id !== lastAssignment.materielId),
                    mat,
                ],
            }
            setStep(materiel ? STEPS.MATERIEL_SITUATION_OF_LAST : STEPS.MATERIEL_ADD)
            setTmpState(prev => ({
                ...prev,
                ...newMat,
                newSituations: uniqBy([{
                    materielCategory,
                    materielId: mat.id,
                    [`id${upperFirst(materielCategory)}`]: mat.id,
                    hash: materielCategory + mat.id,
                    siteCode: piezometerStore.id,
                    siteName: `[${piezometerStore.code}] ${piezometerStore.name}`,
                    siteType: 1,
                    situationDate: getDateWithHour(event.date, event.eventHour).valueOf(),
                    statusCode: 1,
                    previousMateriel: selectedMateriel,
                }, ...tmpNewSituations], 'hash'),
            }))
        }

        const materielsCard = availableTypes?.length ? (
            <Box>
                <Card>
                    <CardContent spacing={1}>
                        <Select
                            options={materielTypesWithCount}
                            value={selectedType}
                            label={i18n.type}
                            onChange={v => setSelectedType(v ? parseInt(v) : undefined)}
                        />
                        <Stack spacing={1} sx={{ maxHeight: '45%' }}>
                            {inStockMateriels.filter(m => m.materielType === type).map(m => (
                                <MaterielCard
                                    key={`stock-${materielCategory}-${m.id}`}
                                    materielCategory={materielCategory}
                                    materielTypeName={(availableTypes.find(t => t.code === m.materielType) || {}).name}
                                    materiel={m}
                                    actions={{ [selectedMateriel ? 'replace' : 'add']: () => onSelectNewMateriel(m) }}
                                />
                            ))}
                        </Stack>
                    </CardContent>
                </Card>
            </Box>
        ) : (
            <Card>
                <CardContent>
                    <Box textAlign='center' onClick={() => setStep(STEPS.MATERIEL_ADD)}>
                        <Typography variant={'h6'}>{i18n.noMaterial}</Typography>
                        <ArrowBackIcon className='clickable' />
                        <Typography>{i18n.returnPreviousStep}</Typography>
                    </Box>
                </CardContent>
            </Card>
        )

        return (
            <Box>
                {getDiagnosticActionHeader(diagnostic, action)}
                <Stack direction='row' alignItems='center' spacing={1} paddingLeft={1} paddingTop={1}>
                    <TrendingFlatIcon />
                    <Typography variant={'h6'}>{`${i18n.materialTypeInStock} ${i18n.selectMaterialTypeAndMaterial}`}</Typography>
                </Stack>
                {materielsCard}
            </Box>
        )
    }

    const getMaterielSituationOfLast = () => {
        const { diagnostics: tmpDiagnostics, actions: tmpActions, newSituations: tmpNewSituations } = tmpState
        const diagnostic = tmpDiagnostics[interventionIndex]
        const action = tmpActions.find(d => d.diagnosticId === diagnostic.codeDiagnostic)

        const assignments = materielsByCategory[materielCategory]?.assignments
        const lastAssignment = assignments?.length ? assignments.find(a => a.materielId === selectedMateriel && !a.situationEndDate) : null
        const materiel = getStationMateriels(lastAssignment, materielCategory)
        const materielType = materiel && materiel.materielType ? materielsByCategory[materielCategory]?.types?.find(t => t.materielType === materiel.materielType) : {}

        const onSelectNewState = statusCode => {
            setStep(STEPS.MATERIEL_ADD)
            setTmpState(prev => ({
                ...prev,
                newSituations: uniqBy([{
                    materielCategory,
                    materielId: materiel.id,
                    [`id${upperFirst(materielCategory)}`]: materiel.id,
                    hash: materielCategory + materiel.id,
                    administratorCode: situationContributor,
                    situationDate: getDateWithHour(event.date, event.eventHour).valueOf(),
                    statusCode,
                }, ...tmpNewSituations], 'hash'),
            }))
        }

        return (
            <NewSituationPanel
                action={action}
                diagnostic={diagnostic}
                materiel={materiel}
                materielCategory={materielCategory}
                materielTypeName={materielType.name}
                onChangeStep={setStep}
                onSelectNewState={onSelectNewState}
                situationContributor={situationContributor}
                onChangeAdministratior={setSituationContributor}
            />
        )
    }

    const getMaterielCategoryToAdd = () => (
        <Stack spacing={0.5}>
            {materielTypes.filter(({ link }) => link !== 'sim').map(({ link, label }) => (
                <Grid
                    key={link}
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    sx={{ cursor: 'pointer', backgroundColor: lightGrey, borderRadius: 3 }}
                    spacing={1}
                    onClick={() => {
                        setStep(STEPS.MATERIEL_CHOICE)
                        setMaterielCategory(link)
                        setSelectedType(undefined)
                        setSelectedMateriel(undefined)
                    }}
                >
                    <Typography variant={'h5'}>{label}</Typography>
                    {getMaterielIconValue(link)}
                </Grid>
            ))}
        </Stack>
    )

    const onChangePiezo = obj => setTmpState(prev => ({ ...prev, piezometer: { ...prev.piezometer, ...obj } }))

    const getPopupPanelStep = () => {
        switch (step) {
            case STEPS.DIAGNOSTIC:
                return (
                    <DiagnosticChoicePanel
                        event={event}
                        diagnostics={tmpState.diagnostics}
                        onChangeDiagnostic={onChangeDiagnostic}
                    />
                )
            case STEPS.ACTION:
                return (
                    <ActionChoicePanel
                        diagnostics={tmpState.diagnostics}
                        actions={tmpState.actions}
                        interventionIndex={interventionIndex}
                        onChangeAction={onChangeAction}
                        goToSelectDiagnostic={() => setStep(STEPS.DIAGNOSTIC)}
                        onChangeDiagnosticIndex={val => setInterventionIndex(prev => {
                            switch (val) {
                                case 'UP': return prev + 1
                                case 'DOWN': return prev - 1
                                default: return 0
                            }
                        })}
                    />
                )
            case STEPS.MATERIEL_ADD:
                return getMaterielCategoryChoice()
            case STEPS.MATERIEL_CHOICE:
                return getMaterielChoice()
            case STEPS.MATERIEL_SITUATION_OF_LAST:
                return getMaterielSituationOfLast()
            case STEPS.MATERIEL_CATEGORY_CHOICE:
                return getMaterielCategoryToAdd()
            case STEPS.LANDMARK_ADD:
                return (
                    <Stack spacing={1} padding={1}>
                        <StationAltimetrySystemsPanel
                            station={tmpState.piezometer}
                            onChange={onChangePiezo}
                            readMode={false}
                            createOnly
                        />
                        <StationLandmarkPanel
                            station={tmpState.piezometer}
                            onChange={onChangePiezo}
                            readMode={false}
                            createOnly
                        />
                    </Stack>
                )
            default:
                return null
        }
    }

    const validatePopup = () => {
        const {
            diagnostics: tmpDiagnostics,
            actions: tmpActions,
            newSituations: tmpNewSituations,
            formActions: tmpFormActions,
            piezometer: tmpPiezometer,
            centrals, sensors, equipments, telecoms, sims, variousMateriels, powerSupplies, subscriptions,
        } = tmpState
        setOpenPopup(false)
        setInterventionIndex(0)
        setStep(STEPS.DEFAULT)
        setDiagnostics(tmpDiagnostics)
        setActions(tmpActions)
        setNewSituations(tmpNewSituations)
        setFormActions(tmpFormActions)
        setPiezometer(tmpPiezometer)
        setMateriels({ centrals, sensors, equipments, telecoms, sims, variousMateriels, powerSupplies, subscriptions })
    }

    const getValidatePopupButton = () => {
        if (step !== STEPS.ACTION) {
            return (
                <Button
                    onClick={() => setStep(STEPS.ACTION)}
                    variant='contained'
                    color='primary'
                    disabled={!tmpState.diagnostics.length}
                >
                    {i18n.next}
                </Button>
            )
        }
        return (
            <Button onClick={validatePopup} variant='contained' color='primary'>
                {i18n.validate}
            </Button>
        )
    }

    const getTechnicalForm = () => (
        <Grid container justifyContent={'center'}>
            <Grid size={8}>
                <Card>
                    <CardTitle title={i18n.event} color={darkBlue}/>
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                {getEventDateCard(false, { active: false, disabled: true })}
                            </Grid>
                            {currentMaterielEventSituation.map(({ materielCategory: category, materielId, statusCode }, index) => {
                                const materiel = materielsByCategory[category]?.materiels?.find(m => m.id === materielId)
                                const materielType = materielsByCategory[category]?.types?.find(t => t.materielType === materiel.materielType)
                                const matState = materielStates.find(s => s.code === statusCode) || {}
                                const matStateIcon = getMaterialStateIcon(matState.code)
                                return (
                                    <Grid size={12} key={`${category}-${materielId}-${index}`}>
                                        <ElementCard
                                            icon={matStateIcon.icon}
                                            iconColor={matStateIcon.color}
                                            color='white'
                                            style={{ color: statusCode === 1 ? 'dodgerBlue' : 'red' }}
                                        >
                                            {`${upperFirst(matState.label)}: ${upperFirst(category)} ${materielType ? `${materielType.name} - ` : ''}${materiel.numLine || materiel.imei || materiel.serialNumber || ''}`}
                                        </ElementCard>
                                    </Grid>
                                )
                            })}
                            <Grid size={12}>
                                <Card>
                                    <CardTitle title={i18n.comment} color={darkBlue} />
                                    <CardContent>
                                        <Textarea value={event.comment} onChange={v => onChangeEvent({ comment: v })} active={false} disabled />
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )

    if (!dataLoaded) {
        return (
            <ProgressCard progress={progress} withMessage/>
        )
    }

    const { eventType } = event

    return (
        <Stack padding={1} spacing={1}>
            {!isLast && !isUpdatable && (
                <Grid container justifyContent={'center'}>
                    <Grid size={8}>
                        <IconCard icon='warning' color='orange' style={{ marginBottom: '5px' }}>
                            {i18n.cantUpdateEventBecause}
                        </IconCard>
                    </Grid>
                </Grid>
            )}
            {eventStore.updateDate && eventStore.updateLogin && (
                <Grid container justifyContent={'center'}>
                    <Grid size={8}>
                        <LastUpdateCard element={eventStore} withHour />
                    </Grid>
                </Grid>
            )}
            {eventType !== EVENT_TYPES_CODES.TECHNIQUE && (
                <Grid container justifyContent={'center'}>
                    <Grid size={8}>
                        <Card>
                            <CardTitle title={i18n.interventionType} color={darkBlue} />
                            <CardContent>
                                <RadioButtons
                                    elements={i18nize(EVENT_TYPES.filter(e => e.code !== EVENT_TYPES_CODES.TECHNIQUE))}
                                    title={i18n.type}
                                    selected={eventType}
                                    onChange={onChangeEventType}
                                    {...disabled}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {eventType === EVENT_TYPES_CODES.PREVENTIVE && getPreventiveCurativeForm(true)}
            {eventType === EVENT_TYPES_CODES.CURATIVE && getPreventiveCurativeForm(false)}
            {eventType === EVENT_TYPES_CODES.TO_PLAN && getToPlanToMonitorCommentForm(false)}
            {eventType === EVENT_TYPES_CODES.TO_MONITOR && getToPlanToMonitorCommentForm(false)}
            {eventType === EVENT_TYPES_CODES.COMMENT && getToPlanToMonitorCommentForm(true)}
            {eventType === EVENT_TYPES_CODES.TECHNIQUE && getTechnicalForm()}
            {eventType === EVENT_TYPES_CODES.NOT_DONE && getToPlanToMonitorCommentForm(false)}
            <Dialog fullWidth maxWidth='md' open={openPopup}>
                <DialogContent>
                    {getPopupPanelStep()}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpenPopup(false)
                            setStep(STEPS.DEFAULT)
                        }}
                        variant='outlined'
                    >
                        {i18n.close}
                    </Button>
                    {getValidatePopupButton()}
                </DialogActions>
            </Dialog>
            <Dialog
                onClose={() => setIsPopupEmailOpen(false)}
                fullWidth
                maxWidth='md'
                open={isPopupEmailOpen}
            >
                <DialogContent>
                    <SelectEmail
                        mailContacts={mails.mailContacts}
                        mailContributors={mails.mailContributors}
                        mailCities={mails.mailCities}
                        mailReceivers={mails.mailReceivers}
                        onChangeEmails={newMails => setMails(prev => ({ ...prev, ...newMails }))}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsPopupEmailOpen(false)} variant='outlined'>
                        {i18n.cancel}
                    </Button>
                    <Button
                        onClick={() => {
                            dispatch(EventsAction.sendEventByMail(STATION_TYPE_NAME.piezometry, id, code, [
                                ...mails.mailContacts,
                                ...mails.mailContributors,
                                ...mails.mailReceivers,
                                ...mails.mailCities,
                            ]))
                            setIsPopupEmailOpen(false)
                        }}
                        variant='contained'
                        color='primary'
                    >
                        {i18n.send}
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    )
}

export default PiezometerEventForm
